import { render } from "./TabsPage.vue?vue&type=template&id=6c09d28e&ts=true"
import script from "./TabsPage.vue?vue&type=script&lang=ts"
export * from "./TabsPage.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\HP 8570W\\Desktop\\Permbledhje Duash VSC\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__